if (document.querySelector("[data-ccm-loader-group]")) {
  import("./modules/ccm19.js").then((module) => module.init());
}

if (document.querySelector(".as-eyeable")) {
  import("./modules/eyeAble.js").then((module) => module.init());
}

if ( document.querySelector(".link-button") || document.querySelector(".icon-button")) {
  import("./modules/navHandler.js").then((module) => module.init());
}


if (document.querySelector(".swiper-container")) {
  import("./modules/swiper.mjs").then((module) => module.init());
}
